import get from 'lodash/get'
import { queryArgs, isNoCampaignsError } from '@/utils'
import eddActions from './eddActions'
import wooActions from './wooActions'

class ResourcesError extends Error {
	constructor (message, response) {
		super(message)
		this.response = response
		this.name = 'ResourcesError'
	}
}

export default {
	...eddActions,
	...wooActions,

	fetchWpResources ({ commit, dispatch, rootGetters }, { exclude = [] }) {
		let wpEndpoint = 'omapp/v1/resources'
		let params = ''
		if (!rootGetters.isFetched('wpResources')) {
			params = queryArgs.add('refresh', 1, params)
		}

		if (exclude.length) {
			params = queryArgs.add('excluded', exclude.join(','), params)
		}

		if (params.length) {
			wpEndpoint += '?' + params
		}

		commit('fetching', 'wpResources', { root: true })

		return new Promise((resolve, reject) => {
			return this._vm.$api
				.get({ wpEndpoint, cached: false })
				.then((response) => {
					const { body } = response

					if (!get(body, 'config')) {
						throw new ResourcesError(
							'No config found in the response (missing response data). There might be an issue with your WordPress sites\'s REST API settings.',
							response
						)
					}

					commit('setError', false)
					commit('fetched', 'wpResources', { root: true })

					if (!exclude.includes('campaigns')) {
						if (!get(body, 'campaigns')) {
							throw new ResourcesError(
								'No campaigns found in the response.',
								response
							)
						}

						dispatch('campaigns/updateCampaignsWithWpData', body.campaigns, { root: true })
						commit('setWpCampaigns', body.campaigns)
					}

					const toUpdate = {
						config : {
							mutation   : 'setWpConfig',
							canExclude : false,
						},
						taxonomies : {
							mutation   : 'setWpTaxonomies',
							canExclude : true,
						},
						posts : {
							mutation   : 'setWpPosts',
							canExclude : true,
						},
						post_types : {
							mutation   : 'setWpPostTypes',
							canExclude : true,
						},
					}
					Object.keys(toUpdate).forEach(k => {
						const prop         = toUpdate[k]
						const canExclude   = !prop.canExclude
						const shouldCommit = !canExclude || !exclude.includes(k)

						if (!shouldCommit) {
							return
						}

						if (!get(body, k)) {
							throw new ResourcesError(
								`No ${k} found in the response. There might be an issue with your WordPress site's `,
								response
							)
						}

						return commit(prop.mutation, body[k])
					})

					this._vm.$bus.$emit('fetchedWpResources', body)
					resolve(body)
				})
				.catch(error => {
					error.explanation = 'Something went wrong while fetching WordPress resources.'

					if (!isNoCampaignsError(error)) {
						// WP-specific error.
						commit('setError', true)
						error.closes = false
						commit('maybeAddError', error, { root: true })
					}

					reject(error)
				})
		})
	},
}
